import React, { useState, useEffect, useRef } from 'react';
import { LabelField } from './Accounting_account.style';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import ConfBar from '../ConfBar/ConfBar';
import './Accounting_account.css'
import { SelectButton } from 'primereact/selectbutton';
import InfoIcon from '../InfoIcon/InfoIcon';
import useInfo from '../hooks/useInfo';
import Video from '../Video/Video';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { FileUpload } from "primereact/fileupload";
import { saveAs } from 'file-saver';
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelExport } from '../../services/excelExport.service';
import { excelReport } from '../../services/excelReport.service';
        

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Accounting_account
Description : Pagina de costos contables para el CRUD de los costos contables del aplicativo remunerlite.
Date Autor Modification
================================================================================
15/10/2021 Cristian Andres Pizo Mina - Pagina de Cargo
5/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Accounting_account() {

  //#region Constantes
  const toast = useRef(null);
  const [third_type_accounting, setThird_type_accounting] = useState("");
  const [nit, setNit] = useState("");
  const setOptions_edit = []
  const setOptions_edit2 = []
  const setOptions_edit3 = []
  const setOptions_edit4 = []
  const setOptions_edit5 = []
  const setOptions_edit6 = []
  const setOptions_edit7 = []
  const [deleteId, setDeleteId] = useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenNit, setIsOpenNit] = React.useState(false);
  const [listaConcepts, setListaConcepts] = useState([]);
  const [listaNumeric_attribute, setListaNumeric_attribute] = useState([]);
  const [listaAccounting_nature, setListaAccounting_nature] = useState([]);
  const [listaType_voucher, setListaType_voucher] = useState([]);
  const [listaThird_type_accounting, setListaThird_type_accounting] = useState([]);
  const [listaType_entity, setListaType_entity] = useState([]);
  const [listaManage_cost, setListaManage_cost] = useState([]);
  const [listaTypeDocument, SetListaTypeDocument] = useState([]);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [rowData, setRowData] = useState([]);
  const headers = { authorization: localStorage.getItem('token') }
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "29rem" };
  const [searchNitDB, setSearchNitDB] = useState(true);
  const [spinerNit, setSpinerNit] = useState(false);
  const [controllerIcon, setControllerIcon] = useState(true);
  const [ct1, setCt1] = useState("");
  const [ct2, setCt2] = useState("");
  const [nature, setNature] = useState("");
  const [voucher_type, setVoucher_type] = useState("");
  const [nameCompany, setNameCompany] = useState("");
  const [nameCompany1, setNameCompany1] = useState("");
  const [entity, setEntity] = useState("");
  const [concept, setConcept] = useState("");
  const [expense, setExpense] = useState("");
  const [typeDocument, setTypeDocument] = useState("");
  const [companyNit, setCompanyNit] = useState("");
  const [digitoVerificacion, setDigitoVerificacion] = useState("");
  const [updateCt1, setUpdateCt1] = useState("");
  const [updateCt2, setUpdateCt2] = useState("");
  const [updateNature, setUpdateNature] = useState("");
  const [updateVoucher_type, setUpdateVoucher_type] = useState("");
  const [updateNameCompany1, setUpdateNameCompany1] = useState("");
  const [updateEntity, setUpdateEntity] = useState("");
  const [updateConcept, setUpdateConcept] = useState("");
  const [updateExpense, setUpdateExpense] = useState("");;
  const [updateThird_type_accounting, setUpdateThird_type_accounting] = useState("");
  const [updateNit, setUpdateNit] = useState("");
  const [accountId, setAccountId] = useState("");
  const [loadingCreateThird, setLoadingCreateThird] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [valueCostCenter, setValueCostCenter] = useState(null);
  const [updateValueCostCenter, setUpdateValueCostCenter] = useState(null);
  const [loadingExport, setLoadingExport] = useState(false);
  const [exportContent, setExportContent] = useState([])
  const [loadPage, setLoadPage] = useState(false)
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [consultado, setConsultado] = useState(false);
  const [isOpenCargue, setIsOpenCargue] = React.useState(false);
  const fileUploadRef = useRef(null);

  const { info } = useInfo("AccountantAccount_Plan")
  // Inicializacion de selects para los costos contables
  useEffect(() => {
    const getLists = async () => {

      await apis.getAccountList(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
        let concepts = res.data["CONCEPTS"]
        let numeric_attribute = res.data["LOV_NUMERIC_ATTRIBUTE"]
        let accounting_nature = res.data["NATURALEZA_CONTABILIDAD"]
        let type_voucher = res.data["TIPO_COMPROBANTE"]
        let third_type_accounting = res.data["TIPO_TERCERO_CONTABILIDAD"]
        let type_entity = res.data["TYPE_ENTITY"]
        let manage_cost = res.data["MANAGE_COST"]
        let contenidoConcepts = []
        let contenidoNumeric_attribute = []
        let contenidoAccounting_nature = []
        let contenidoType_voucher = []
        let contenidoThird_type_accounting = []
        let contenidoType_entity = []
        let contenidoManage_cost = []

        concepts.forEach(element => {
          contenidoConcepts.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
        })
        setListaConcepts(contenidoConcepts);

        numeric_attribute.forEach(element => {
          contenidoNumeric_attribute.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        setListaNumeric_attribute(contenidoNumeric_attribute);

        accounting_nature.forEach(element => {
          contenidoAccounting_nature.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        setListaAccounting_nature(contenidoAccounting_nature);

        type_voucher.forEach(element => {
          contenidoType_voucher.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        setListaType_voucher(contenidoType_voucher);

        third_type_accounting.forEach(element => {
          contenidoThird_type_accounting.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        setListaThird_type_accounting(contenidoThird_type_accounting);

        type_entity.forEach(element => {
          contenidoType_entity.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        setListaType_entity(contenidoType_entity);

        manage_cost.forEach(element => {
          contenidoManage_cost.push({ "value": '' + element.detail_id + '', "name": '' + element.description + '' });
        })
        setListaManage_cost(contenidoManage_cost);
        setValueCostCenter(contenidoManage_cost[1].value);

      })

      await apis.getThirdList(headers).then(res => {
        let thirdDocument = res.data["THIRDS"]["TIPO DE IDENTIDAD"]
        let contenidoTypeDocument = []

        thirdDocument.forEach(element => {
          contenidoTypeDocument.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        SetListaTypeDocument(contenidoTypeDocument);
      })
      setTabla()
    }
    getLists()
  }, []);

  // función para mostrar modal
  const showModal = () => {
    setIsOpen(true);
    console.log(info)
  };

  // función para modal del nit
  const showModalNit = () => {
    setIsOpenNit(true);
  };

  // función para cerrar modal y limpiar campos del formulario
  const hideModalNit = () => {
    setIsOpenNit(false);
    cleanThird();
  };

  // función para cerrar modal y limpiar campos del formulario
  const hideModal = () => {
    limpiar();
    setIsOpen(false);
  };

  // función para mostrar modal
  const showModal_ = () => {
    setIsOpen_(true);
  };

  // función para cerrar modal
  const hideModal_ = () => {
    setIsOpen_(false)
  };

  // función para mostrar modal para confirmar eliminar elemento
  const showModalEliminar = (ACCOUNT_ID) => {
    setDeleteId(ACCOUNT_ID);
    setIsOpenEliminar(true);
  };

  // función para cerrar modal
  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalCargue = () => {
    setIsOpenCargue(true);
  };

  const hideModalCargue = () => {
    setIsOpenCargue(false);
  };

  // función para inizializar datos al editar un elemento
  function inizilaizarData(rowData) {
    console.log(rowData)
    setOptions_edit.push({ "value": '' + rowData["Id naturaleza"] + '', "label": '' + rowData["Naturaleza"] + '' });
    setOptions_edit2.push({ "value": '' + rowData["Id comprobante"] + '', "label": '' + rowData["Tipo de Comprobante"] + '' });
    setOptions_edit3.push({ "value": '' + rowData["Id tercero"] + '', "label": '' + rowData["Tipo de Tercero"] + '' });
    setOptions_edit4.push({ "value": '' + rowData["Id entidad"] + '', "label": '' + rowData["Tipo de Entidad"] + '' });
    setOptions_edit5.push({ "value": '' + rowData["Concepto"] + '', "label": '' + rowData["Nombre del Concepto"] + '' });
    setOptions_edit6.push({ "value": '' + rowData["Id gasto"] + '', "label": '' + rowData["Tipo de gasto"] + '' });
    setOptions_edit7.push({ name: '' + rowData["Maneja centro de costo"] + '', value: '' + rowData["Id centro costo"] + '' });
    setUpdateCt1(rowData["Cuenta 1"])
    setUpdateCt2(rowData["Cuenta 2"])
    setUpdateNature(setOptions_edit[0])
    setUpdateVoucher_type(setOptions_edit2[0])
    setUpdateThird_type_accounting(setOptions_edit3[0])
    setThird_type_accounting(toString(setOptions_edit3[0].value))
    setUpdateNit(rowData.NIT)
    setUpdateNameCompany1(rowData["Nombre tercero"])
    setUpdateEntity(setOptions_edit4[0])
    setUpdateConcept(setOptions_edit5[0])
    setUpdateExpense(setOptions_edit6[0])
    setAccountId(rowData["Id configuración"])
    setUpdateValueCostCenter(setOptions_edit7[0].value)

    showModal_();
  }

  // función para limpiar campos del formulario
  async function limpiar() {
    setCt1("")
    setCt2("")
    setNature("")
    setVoucher_type("")
    setThird_type_accounting("")
    setEntity("")
    setConcept("")
    setExpense("")
    setNit("")
    setNameCompany1("")
  }

  // Función para limpiar campos del formulario
  async function cleanThird() {
    setCompanyNit("");
    setNameCompany("");
    setDigitoVerificacion("");
    setTypeDocument("")

  }

  // Función para validar campos vacios del formulario
  function validar() {
    if (ct1 == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar cuenta 1', life: 4000 });
      return false
    } if (nature.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar Naturaleza', life: 4000 });
      return false
    } if (voucher_type.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar Tipo de comprobante', life: 4000 });
      return false
    } if (third_type_accounting.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar Tipo tercero', life: 4000 });
      return false
    } if (concept.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar Concepto', life: 4000 });
      return false
    } if (valueCostCenter == null) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar si tiene centro de costo', life: 4000 });
      return false
    }

    return true
  }

  // Función para validar campos vacios del formulario de tercero
  function validarThird() {
    if (typeDocument.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar Tipo de documento', life: 4000 });
      return false
    } if (companyNit == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar nit de la empresa', life: 4000 });
      return false
    } if (nameCompany == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar nombre de la empresa', life: 4000 });
      return false
    }
    return true

  }

  // Función para cargar datos de la tabla
  async function setTabla() {
    await apis.getAccount(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["PARAMETERS_ACCOUNT"].length > 0) {
        let data = res.data["PARAMETERS_ACCOUNT"]
        let contenidoTabla = []
        let contendidoExport = []
        console.log(data)
        data.forEach(element => {
          let nature = element["NATURE"].split("|")
          let voucher_type = element["VOUCHER_TYPE"].split("|")
          let third_type = element["THIRD_TYPE"].split("|")
          let type_ent = element["LOV_TYPE_ENT"].split("|")
          let concept = element["CONCEPT"].split("|")
          let cond_ctb = element["COND_CTB"].split("|")
          let manage_cost = element["MANAGE_COST"].split("|")
          let nit = element["NIT"].split("|")
          let concept_nature = element["CONCEPT_NATU"].split("|")
          contenidoTabla.push({
            'Id configuración': element.ACCOUNT_ID, 'Cuenta 1': element.CTA1, 'Cuenta 2': element.CTA2, "Id naturaleza": nature[0],
            Naturaleza: nature[1], "Id comprobante": voucher_type[0], 'Tipo de Comprobante': voucher_type[1], "Id tercero": third_type[0],
            'Tipo de Tercero': third_type[1], NIT: nit[0], "Nombre tercero": nit[1], 'Id entidad': type_ent[0],
            'Tipo de Entidad': type_ent[1], Concepto: concept[0], 'Nombre del Concepto': element.CONCEPT, "Id gasto": cond_ctb[0], 'Tipo de Gasto': cond_ctb[1],
            'Id centro costo': manage_cost[0], 'Maneja centro de costo': manage_cost[1], concept_nat_id: concept_nature[0], concept_nat: concept_nature[1]
          })
          contendidoExport.push({
            'Id configuración': element.ACCOUNT_ID, Concepto: concept[0], 'Nombre del Concepto': concept[1], 'Tipo del Concepto': concept_nature[1],
            'Cuenta 1': element.CTA1, 'Cuenta 2': element.CTA2, Naturaleza: nature[1], 'Tipo de Tercero': third_type[1], NIT: nit[0], "Nombre tercero": nit[1],
            'Tipo de Entidad': type_ent[1], 'Tipo de Gasto': cond_ctb[1], 'Maneja centro de costo': manage_cost[1], 'Tipo de Comprobante': voucher_type[1]
          })
        })
        setRowData(contenidoTabla)
        setExportContent(contendidoExport)
        setLoadPage(true)
      } else {
        setRowData([])
        setExportContent([])
        setLoadPage(true)
      }
    }).catch(err => {
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  // Función para guardar centro de costos
  async function completarRegistro() {


    if (validar()) {
      setLoadingCreate(true)
      const _ct1 = ct1;
      const _ct2 = ct2;
      const _nature = nature.value;
      const _type_voucher = voucher_type.value;
      const _third_type = third_type_accounting.value;
      const _nit = nit;
      const _lov_type_ent = entity.value;
      const _concept = concept.value;
      const _cond_ctb = expense.value;
      const _client = localStorage.getItem('client');
      const _entity = localStorage.getItem('entity')
      const _manage_cost = valueCostCenter;
      let account


      if (_third_type == "14630") {
        account = {
          CLIENT: _client,
          ENTITY: _entity,
          CTA1: _ct1,
          CTA2: _ct2,
          NATURE: _nature,
          VOUCHER_TYPE: _type_voucher,
          THIRD_TYPE: _third_type,
          NIT: _nit,
          LOV_TYPE_ENT: '',
          CONCEPT: _concept,
          MANAGE_COST: _manage_cost,
          COND_CTB: _cond_ctb
        }

      } if (_third_type == "14631") {
        account = {
          CLIENT: _client,
          ENTITY: _entity,
          CTA1: _ct1,
          CTA2: _ct2,
          NATURE: _nature,
          VOUCHER_TYPE: _type_voucher,
          THIRD_TYPE: _third_type,
          NIT: '',
          LOV_TYPE_ENT: _lov_type_ent,
          CONCEPT: _concept,
          MANAGE_COST: _manage_cost,
          COND_CTB: _cond_ctb
        }

      } if (_third_type == "14629") {
        account = {
          CLIENT: _client,
          ENTITY: _entity,
          CTA1: _ct1,
          CTA2: _ct2,
          NATURE: _nature,
          VOUCHER_TYPE: _type_voucher,
          THIRD_TYPE: _third_type,
          NIT: '',
          LOV_TYPE_ENT: '',
          CONCEPT: _concept,
          MANAGE_COST: _manage_cost,
          COND_CTB: _cond_ctb
        }

      } if (_third_type == "14628") {
        account = {
          CLIENT: _client,
          ENTITY: _entity,
          CTA1: _ct1,
          CTA2: _ct2,
          NATURE: _nature,
          VOUCHER_TYPE: _type_voucher,
          THIRD_TYPE: _third_type,
          NIT: '',
          LOV_TYPE_ENT: '',
          CONCEPT: _concept,
          MANAGE_COST: _manage_cost,
          COND_CTB: _cond_ctb
        }
      }

      await apis.postAccount(account, headers).then(res => {
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Plan de cuenta agregado exitosamente', life: 4000 });
        setLoadingCreate(false)
        hideModal();
        setTabla();
        limpiar();
      }).catch(err => {
        setLoadingCreate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
  }


  // Función para guardar tercero
  async function postThird() {

    if (validarThird()) {
      setLoadingCreateThird(true)
      const _typeDocument = typeDocument.value;
      const _companyNit = companyNit;
      const _nameCompany = nameCompany;
      const _client = localStorage.getItem('client');
      const _entity = localStorage.getItem('entity')
      const _digitoVerificacion = digitoVerificacion

      const third = {
        CLIENT: _client,
        ENTITY: _entity,
        NIT: _companyNit,
        DOCUMENT_TYPE: _typeDocument,
        DV: _digitoVerificacion,
        NAME: _nameCompany
      }

      await apis.postThird(third, headers).then(res => {
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Tercero creado con éxito', life: 4000 });
        setLoadingCreateThird(false)
        setNameCompany(third.NAME);
        setNit(third.NIT);
        searchNit(third.NIT);
        hideModalNit();
      }).catch(err => {
        setLoadingCreateThird(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
  }

  // Función para actualizar centro de costo
  async function actualizar() {
    setLoadingUpdate(true)
    const _ct1 = updateCt1;
    const _ct2 = updateCt2;
    const _nature = updateNature.value;
    const _type_voucher = updateVoucher_type.value;
    const _third_type = updateThird_type_accounting.value;
    const _nit = updateNit;
    const _lov_type_ent = updateEntity.value;
    const _concept = updateConcept.value;
    const _cond_ctb = updateExpense.value;
    const _client = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _account = accountId
    const _manage_cost = updateValueCostCenter;
    let account


    if (_third_type == "14630") {
      account = {
        CLIENT: _client,
        ENTITY: _entity,
        CTA1: _ct1,
        CTA2: _ct2,
        NATURE: _nature,
        VOUCHER_TYPE: _type_voucher,
        THIRD_TYPE: _third_type,
        NIT: _nit,
        LOV_TYPE_ENT: '',
        CONCEPT: _concept,
        COND_CTB: _cond_ctb,
        MANAGE_COST: _manage_cost,
        ACCOUNT_ID: _account
      }

    } if (_third_type == "14631") {
      account = {
        CLIENT: _client,
        ENTITY: _entity,
        CTA1: _ct1,
        CTA2: _ct2,
        NATURE: _nature,
        VOUCHER_TYPE: _type_voucher,
        THIRD_TYPE: _third_type,
        NIT: '',
        LOV_TYPE_ENT: _lov_type_ent,
        CONCEPT: _concept,
        COND_CTB: _cond_ctb,
        MANAGE_COST: _manage_cost,
        ACCOUNT_ID: _account
      }

    } if (_third_type == "14629") {
      account = {
        CLIENT: _client,
        ENTITY: _entity,
        CTA1: _ct1,
        CTA2: _ct2,
        NATURE: _nature,
        VOUCHER_TYPE: _type_voucher,
        THIRD_TYPE: _third_type,
        NIT: '',
        LOV_TYPE_ENT: '',
        CONCEPT: _concept,
        COND_CTB: _cond_ctb,
        MANAGE_COST: _manage_cost,
        ACCOUNT_ID: _account
      }

    } if (_third_type == "14628") {
      account = {
        CLIENT: _client,
        ENTITY: _entity,
        CTA1: _ct1,
        CTA2: _ct2,
        NATURE: _nature,
        VOUCHER_TYPE: _type_voucher,
        THIRD_TYPE: _third_type,
        NIT: '',
        LOV_TYPE_ENT: '',
        CONCEPT: _concept,
        COND_CTB: _cond_ctb,
        MANAGE_COST: _manage_cost,
        ACCOUNT_ID: _account
      }
    }

    await apis.putAccount(account, headers).then(res => {
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Plan de cuenta agregado exitosamente', life: 4000 });
      setLoadingUpdate(false)
      setIsOpen_(false);
      setTabla();
      limpiar();
    }).catch(err => {
      setLoadingUpdate(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })



  }

  // Función para eliminar centro de costo
  async function eliminar() {
    setLoadingDelete(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');
    const _accountId = deleteId;
    console.log(deleteId)
    await apis.deleteAccount(_entity, _cliente, _accountId, headers).then(res => {
      setLoadingDelete(false)
      setIsOpenEliminar(false)
      toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Plan de cuentas eliminado', life: 4000 });
    }).catch(err => {
      setLoadingDelete(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })

    setTabla();
  }





  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModal} />
        <Button label="Cargue" icon="pi pi-upload" className="p-button-success mr-2 p-button-sm" onClick={showModalCargue} />
      </React.Fragment>
    )
  }

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Exportar" icon="pi pi-file-excel" tooltip='Exportar información de la tabla' loading={loadingExport}
          tooltipOptions={{ position: 'top' }} className="p-button-success mr-2 p-button-sm" onClick={() => { setLoadingExport(true); exportExcel() }} />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" className="p-button-warning  p-button-sm text-xs mr-2" tooltip="Editar cuenta contable" tooltipOptions={{ position: 'top' }} onClick={() => { inizilaizarData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs" tooltip="Eliminar cuenta contable" tooltipOptions={{ position: 'top' }} onClick={() => { showModalEliminar(rowData["Id configuración"]) }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }




  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'Nombre del Concepto': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'concept_nat': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Cuenta 1': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Cuenta 2': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Naturaleza': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Tipo de Comprobante': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Tipo de Tercero': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NIT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Tipo de Entidad': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Tipo de Gasto': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Maneja centro de costo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];


  // Pie de pagina del modal
  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={completarRegistro} label='Guardar' loading={loadingCreate}></Button>
    </div>
  );

  //Pie de pagina del modal para terceros
  const addFooterThird = (
    <div>
      <Button onClick={hideModalNit}>Cancelar</Button>
      <Button onClick={postThird} label='Guardar' loading={loadingCreateThird}></Button>
    </div>
  );

  // Encabezado del modal
  const addHeader = (
    <div>
      <h3>Agregar Plan de cuentas contables</h3>
    </div>
  );

  // Encabezado del modal terceros
  const addHeaderThird = (
    <div>
      <h3>Crear Tercero</h3>
    </div>
  );

  // Pie de pagina del modal para editar
  const updateFooter = (
    <div>
      <Button onClick={hideModal_}>Cancelar</Button>
      <Button onClick={actualizar} label='Guardar' loading={loadingUpdate}></Button>
    </div>
  );

  // Encabezado del modal para editar
  const updateHeader = (
    <div>
      <h3>Actualizar Plan de cuentas contables</h3>
    </div>
  );

  // Encabezado del modal para elimnar centro de costos
  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button onClick={eliminar} label='Si' loading={loadingDelete}></Button>
    </div>
  );

  // Encabezado del modal para elimnar centro de costos
  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el Plan de cuentas?</h3>
    </div>
  );

  // Función para buscar el nit del tercero
  const searchNit = async (event) => {
    setNit(event);
    setSpinerNit(true)
    setSearchNitDB(true)
    setControllerIcon(false)

    if (event != '') {
      await apis.getValNit(localStorage.getItem('entity'), localStorage.getItem('client'), event, headers).then(res => {
        let data = res.data;
        setNameCompany1(data["NAME"])

        if (data["NIT"].length > 0) {
          setSpinerNit(false)
          setSearchNitDB(true)
          setControllerIcon(false)
        }

      }).catch(err => {
        setNameCompany1("")
        setSearchNitDB(false)
      })
    } else {
      setControllerIcon(true)
    }

  }

  // Función para buscar el nit del tercero en el modal de editar
  const searchUpdateNit = async (event) => {
    setUpdateNit(event);
    setSpinerNit(true)
    setSearchNitDB(true)
    setControllerIcon(false)

    if (event != '') {
      await apis.getValNit(localStorage.getItem('entity'), localStorage.getItem('client'), event, headers).then(res => {
        let data = res.data;
        setUpdateNameCompany1(data["NAME"])

        if (data["NIT"].length > 0) {
          setSpinerNit(false)
          setSearchNitDB(true)
          setControllerIcon(false)
        }

      }).catch(err => {
        setUpdateNameCompany1("")
        setSearchNitDB(false)
      })
    } else {
      setControllerIcon(true)
    }

  }

  async function downloadSampleFile() {
    let payload = {
      NAME: "UploadParamsAccount",
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.uploadParamsAccount(payload, headers).then(res => {
        sampleFile = res.data
        let nombre = sampleFile["SHEETS"][0]["NAME"]
        excelReport(sampleFile, nombre)
        setLoading5(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      setLoading5(false)
    }
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "ErroresCargue.txt");
  }

  async function importData(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.uploadParamsAccount(_importedData, headers).then(res => {
        setConsultado(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
        setTabla()
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importCargue(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado(true);
    showConfirm();
    const file = e.files[0];

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadParamsAccount",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importData(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  const showConfirm = () => {
    /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
    toast.current.show({
      severity: 'info', sticky: true, content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i >
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
            </i>
            <p>Cargando información...</p>
          </div>
        </div>
      )
    });
  }

  const exportExcel = () => {
    try{
      excelExport(exportContent, 'PlanDeCuentasContables')
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Exportado con éxito" });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error al exportar", sticky: true });
    }
    finally{
      setLoadingExport(false);
    }
  }

  const rowClassName = (rowData) => {
    let style = { 'warn-row': (rowData["Cuenta 1"].includes("*")) }
    return style
  }

  const bodyTemplate = (rowData) => {
    return rowData["Cuenta 1"]
  }

  // Cuerpo del modal de tercero
  const typeThird = (

    <div>
      <Tooltip target=".info" className='indigo-tooltip ml-1' />
      <LabelField htmlFor="label">Concepto</LabelField>
      <InfoIcon msg={info[0]}
        element={
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={concept.value} options={listaConcepts} placeholder={"Seleccione Conceptos"} onChange={setConcept} />
        }
      />
      <LabelField htmlFor="label">Cuenta 1</LabelField>
      <InfoIcon msg={info[1]}
        element={
          <InputText style={{ width: "29rem" }} value={ct1} onChange={(e) => setCt1(e.target.value)} placeholder="Cuenta 1" />
        }
      />
      <LabelField htmlFor="label">Cuenta 2</LabelField>
      <InfoIcon msg={info[2]}
        element={
          <InputText style={{ width: "29rem" }} value={ct2} onChange={(e) => setCt2(e.target.value)} placeholder="Cuenta 2" />
        }
      />
      <LabelField htmlFor="label">Naturaleza de la cuenta</LabelField>
      <InfoIcon msg={info[3]}
        element={
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={nature.value} options={listaAccounting_nature} placeholder={"Seleccione naturaleza de la cuenta"} onChange={setNature} />
        }
      />
      <LabelField htmlFor="label">Tipo de comprobante</LabelField>
      <InfoIcon msg={info[4]}
        element={
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={voucher_type.value} options={listaType_voucher} placeholder={"Seleccione tipo de comprobante"} onChange={setVoucher_type} />
        }
      />
      <LabelField htmlFor="label">Tipo de tercero</LabelField>
      <InfoIcon msg={info[5]}
        element={
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={third_type_accounting.value} options={listaThird_type_accounting} placeholder={"Seleccione tipo tercero"} onChange={setThird_type_accounting} />
        }
      />
      {third_type_accounting.value == "14630" ?
        <div>
          <Tooltip target=".info" className='indigo-tooltip ml-1' />
          <LabelField htmlFor="label">Nit</LabelField>
          {searchNitDB ?
            <>
              <Tooltip target=".info" className='indigo-tooltip ml-1' />
              <span className="p-input-icon-right">
                {controllerIcon ? null :
                  <div>
                    {spinerNit ? <i className="pi pi-spin pi-spinner" /> : <i className="pi pi-check text-green-500" />}
                  </div>
                }

              </span>
              <InfoIcon msg={info[6]}
                element={
                  <InputText autoFocus style={{ width: "29rem" }} value={nit} onChange={(e) => searchNit(e.target.value)} placeholder="Ingrese número de Nit" />
                }
              />
            </>
            :
            <div>
              <Tooltip target=".info" className='indigo-tooltip ml-1' />
              <InfoIcon msg={info[6]}
                element={
                  <div className="p-inputgroup">
                    <Tooltip target=".info" className='indigo-tooltip ml-1' />
                    <InputText autoFocus className="p-invalid block" value={nit} onChange={(e) => searchNit(e.target.value)} placeholder="Ingrese número de Nit" />
                    <Button icon="pi pi-plus" className="p-button-success" onClick={showModalNit} />
                  </div>
                }
              />
              <small id="username2-help" className="p-error block">Debe agregar Nit con el boton +</small>
            </div>
          }

          <LabelField htmlFor="label">Nombre de empresa</LabelField>
          <InfoIcon msg={info[7]}
            element={
              <InputText style={{ width: "29rem" }} value={nameCompany1} onChange={(e) => setNameCompany1(e.target.value)} placeholder="Nombre de empresa" disabled />
            }
          />
        </div>

        : null}

      {third_type_accounting.value == "14631" ?
        <div>
          <Tooltip target=".info" className='indigo-tooltip ml-1' />
          <LabelField htmlFor="label">Tipo de Entidad</LabelField>
          <InfoIcon msg={info[8]}
            element={
              <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={entity.value} options={listaType_entity} placeholder={"Seleccione tipo entidad"} onChange={setEntity} />
            }
          />
        </div>
        : null}

      <LabelField htmlFor="label">Tipo de gasto</LabelField>
      <InfoIcon msg={info[9]}
        element={
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={expense.value} options={listaNumeric_attribute} placeholder={"Seleccione tipo de gasto"} onChange={setExpense} />
        }
      />

      <LabelField htmlFor="label">¿Maneja centro costo?</LabelField>
      <InfoIcon msg={info[10]}
        element={
          <SelectButton value={valueCostCenter} options={listaManage_cost} onChange={(e) => setValueCostCenter(e.value)} optionLabel="name" />
        }
      />
    </div>
  );

  const footer = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading5(false); setLoading6(false); hideModalCargue() }} />
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading5} onClick={() => { setLoading5(true); downloadSampleFile() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargue}>
      </FileUpload>
    </div>
  );

  const header = (
    <div>
      <h3>Cargar plan de cuentas contables</h3>
    </div>
  )

  // Return que entrega la pantalla
  return (

    <div>

      <Toast ref={toast} />
      <Tooltip target=".info" className='indigo-tooltip ml-1' />
      <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
        <span className="text-900">Plan de cuentas contables</span>
        <Video header="Instructivo plan de cuentas contables" url={localStorage.getItem("ACCOUNTANTACCOUNT_PLAN_VIDEO")} />
      </div>

      <ConfBar />

      <div className="surface-100	 px-4 py-2 md:px-6 lg:px-8">
        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" draggable={false} resizable={false} modal onHide={hideModal}>
          {typeThird}
        </Dialog>

        <Dialog header={addHeaderThird} footer={addFooterThird} visible={isOpenNit} position="top" style={{ width: "32rem" }} draggable={false} resizable={false} modal onHide={hideModalNit}>
          <LabelField htmlFor="label">Tipo de documento</LabelField>
          <Dropdown style={elementWidth} value={typeDocument.value} options={listaTypeDocument} onChange={setTypeDocument} placeholder={"Selecione tipo de documento"} />
          <LabelField htmlFor="label">Nit</LabelField>
          <InputText style={{ width: "29rem" }} value={companyNit} onChange={(e) => setCompanyNit(e.target.value)} placeholder="Ingrese nit" />
          <LabelField htmlFor="label">Dígito de verificación</LabelField>
          <div class="block">
            <InputText
              style={{ width: "3rem" }}
              type="text"
              maxLength={1}
              value={digitoVerificacion}
              onChange={(e) => setDigitoVerificacion(e.target.value)}
            />
          </div>
          <LabelField htmlFor="label">Nombre de la entidad</LabelField>
          <InputText style={{ width: "29rem" }} value={nameCompany} onChange={(e) => setNameCompany(e.target.value)} placeholder="Ingrese nombre de la entidad" />

        </Dialog>

        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal_} >
          <LabelField htmlFor="label">Concepto</LabelField>
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} placeholder={updateConcept.label} value={updateConcept.value} options={listaConcepts} onChange={setUpdateConcept} />

          <LabelField htmlFor="label">Cuenta 1</LabelField>
          <InputText style={{ width: "29rem" }} value={updateCt1} onChange={(e) => setUpdateCt1(e.target.value)} placeholder="Cuenta 1" />
          <LabelField htmlFor="label">Cuenta 2</LabelField>
          <InputText style={{ width: "29rem" }} value={updateCt2} onChange={(e) => setUpdateCt2(e.target.value)} placeholder="Cuenta 2" />
          <LabelField htmlFor="label">Naturaleza de la cuenta</LabelField>
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={updateNature.value} options={listaAccounting_nature} placeholder={updateNature.label} onChange={setUpdateNature} />
          <LabelField htmlFor="label">Tipo de comprobante</LabelField>
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={updateVoucher_type.value} options={listaType_voucher} placeholder={updateVoucher_type.label} onChange={setUpdateVoucher_type} />
          <LabelField htmlFor="label">Tipo de tercero</LabelField>
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} value={updateThird_type_accounting.value} options={listaThird_type_accounting} placeholder={updateThird_type_accounting.label} onChange={setUpdateThird_type_accounting} />


          {updateThird_type_accounting.value == "14630" ?
            <div>
              <LabelField htmlFor="label">Nit</LabelField>
              {searchNitDB ?
                <span className="p-input-icon-right">
                  {controllerIcon ? null :
                    <div>
                      {spinerNit ? <i className="pi pi-spin pi-spinner" /> : <i className="pi pi-check text-green-500" />}
                    </div>
                  }
                  <InputText autoFocus style={{ width: "29rem" }} value={updateNit} onChange={(e) => searchUpdateNit(e.target.value)} placeholder="Ingrese número de Nit" />
                </span>
                :
                <div>
                  <div className="p-inputgroup">
                    <InputText autoFocus className="p-invalid block" value={updateNit} onChange={(e) => searchUpdateNit(e.target.value)} placeholder="Ingrese número de Nit" />
                    <Button icon="pi pi-plus" className="p-button-success" onClick={showModalNit} />
                  </div>
                  <small id="username2-help" className="p-error block">Debe agregar Nit con el boton +</small>
                </div>
              }

              <LabelField htmlFor="label">Nombre de empresa</LabelField>
              <InputText style={{ width: "29rem" }} value={updateNameCompany1} onChange={(e) => setUpdateNameCompany1(e.target.value)} placeholder="Nombre de empresa" disabled />

            </div>

            : null}

          {updateThird_type_accounting.value == "14631" ?
            <div>
              <LabelField htmlFor="label">Tipo de Entidad</LabelField>
              <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} placeholder={updateEntity.label} value={updateEntity.value} options={listaType_entity} onChange={setUpdateEntity} />
            </div>
            : null}

          <LabelField htmlFor="label">Tipo de gasto</LabelField>
          <Dropdown filter showClear filterBy="label" optionLabel="label" style={elementWidth} placeholder={updateExpense.label} value={updateExpense.value} options={listaNumeric_attribute} onChange={setUpdateExpense} />
          <LabelField htmlFor="label">¿Maneja centro costo?</LabelField>
          <SelectButton value={updateValueCostCenter} options={listaManage_cost} onChange={(e) => setUpdateValueCostCenter(e.value)} optionLabel="name" />
        </Dialog>

        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <Dialog header={header} footer={footer} visible={isOpenCargue}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCargue}>
          <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
          <br />
          <span>2. Diligencie la hoja UploadParamsAccount, teniendo en cuenta los códigos de concepto presentados en la hoja Conceptos del cliente.</span>
          <br />
          <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
        </Dialog>

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate} />
            <DataTable className="datatable-style-demo text-xs" value={rowData} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              scrollHeight="flex" dataKey="ACCOUNT_ID"
              size="small" filters={filters1} filterDisplay="menu"
              globalFilterFields={['ACCOUNT_ID', 'Nombre del Concepto', 'concept_nat', 'Cuenta 1', 'Cuenta 2', 'Naturaleza', 'NIT', 'Tipo de Entidad', 'Tipo de Gasto', 'Maneja centro de costo']}
              header={header1} rowClassName={rowClassName}>
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              {/* <Column field="ACCOUNT_ID" header="ID"   filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column> */}
              <Column field="Nombre del Concepto" header="Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre concepto" sortable></Column>
              <Column field="concept_nat" header="Tipo del Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo concepto" sortable></Column>
              <Column field="Cuenta 1" header="Cuenta 1" body={bodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cuenta 1" sortable></Column>
              <Column field="Cuenta 2" header="Cuenta 2" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cuenta 2" sortable></Column>
              <Column field="Naturaleza" header="Naturaleza" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Naturaleza" sortable></Column>
              <Column field="Tipo de Comprobante" header="Tipo comprobante" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo comprobante" sortable></Column>
              <Column field="Tipo de Tercero" header="Tipo tercero" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo tercero" sortable></Column>
              <Column field="NIT" header="Tercero" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tercero" sortable></Column>
              <Column field="Tipo de Entidad" header="Tipo entidad" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo entidad" sortable></Column>
              <Column field="Tipo de Gasto" header="Tipo de gasto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo gasto" sortable></Column>
              <Column field="Maneja centro de costo" header="¿Maneja centro costo?" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ¿Maneja centro costo?" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}